<template>
  <header class="site-header">
    <nav class="navbar">
      <router-link to="/" class="logo-link" @click="closeMenu">
        <img src="/ollogosm.png" alt="Organlive Logo" class="logo" />
      </router-link>

      <!-- Hamburger Button -->
      <button class="hamburger" @click="toggleMenu" :class="{ active: isMenuOpen }">
        <span></span>
        <span></span>
        <span></span>
      </button>

      <!-- Navigation Links -->
      <ul class="nav-links" :class="{ open: isMenuOpen }">
        <li class="dropdown" @mouseenter="openDropdown" @mouseleave="closeDropdown">
          <a href="#" @click.prevent="toggleDropdown" class="dropdown-toggle">
            Library
            <span class="arrow" :class="{ open: isDropdownOpen }">▼</span>
          </a>
          <ul class="dropdown-menu" :class="{ show: isDropdownOpen }">
            <li><router-link to="/search" @click="closeMenus">Search</router-link></li>
            <li><router-link to="/newadditions" @click="closeMenus">New Additions</router-link></li>
            <li><router-link to="/recenttracks" @click="closeMenus">Recent Tracks</router-link></li>
          </ul>
        </li>
        <li><router-link to="/contact" @click="closeMenu">Contact</router-link></li>
        <li><router-link to="/support" @click="closeMenu">Support</router-link></li>
        <li class="dropdown" @mouseenter="openListenDropdown" @mouseleave="closeListenDropdown">
          <a href="#" @click.prevent="toggleListenDropdown" class="dropdown-toggle">
            Tune In
            <span class="arrow" :class="{ open: isListenDropdownOpen }">▼</span>
          </a>
          <ul class="dropdown-menu" :class="{ show: isListenDropdownOpen }">
            <li><a href="#" @click.prevent="startAudio">Listen</a></li>
            <li><router-link to="/mobileapps" @click="closeMenus">Mobile Apps</router-link></li>
            <li><router-link to="/streams" @click="closeMenus">Streams</router-link></li>
          </ul>
        </li>
      </ul>
    </nav>
  </header>
</template>

<script>
import eventBus from '@/eventBus'

export default {
  name: 'SiteHeader',
  data () {
    return {
      isMenuOpen: false,
      isDropdownOpen: false,
      isListenDropdownOpen: false
    }
  },
  methods: {
    toggleAudio () {
      eventBus.emit('toggle-play')
      this.closeMenu()
    },
    startAudio () {
      eventBus.emit('start-play')
      this.closeMenus()
    },
    toggleMenu () {
      this.isMenuOpen = !this.isMenuOpen
    },
    closeMenu () {
      this.isMenuOpen = false
      this.isDropdownOpen = false
      this.isListenDropdownOpen = false
    },
    toggleDropdown () {
      this.isDropdownOpen = !this.isDropdownOpen
    },
    openDropdown () {
      // Only auto-open on hover for desktop (non-touch devices)
      if (window.innerWidth > 768) {
        this.isDropdownOpen = true
      }
    },
    closeDropdown () {
      // Only auto-close on mouse leave for desktop
      if (window.innerWidth > 768) {
        this.isDropdownOpen = false
      }
    },
    toggleListenDropdown () {
      this.isListenDropdownOpen = !this.isListenDropdownOpen
    },
    openListenDropdown () {
      // Only auto-open on hover for desktop (non-touch devices)
      if (window.innerWidth > 768) {
        this.isListenDropdownOpen = true
      }
    },
    closeListenDropdown () {
      // Only auto-close on mouse leave for desktop
      if (window.innerWidth > 768) {
        this.isListenDropdownOpen = false
      }
    },
    closeMenus () {
      this.closeMenu()
    }
  }
}
</script>

<style scoped>
/* Header uses the same blue (#003366) as the AudioPlayer */
.site-header {
  background-color: #003366;
  padding: 0;
  margin: 0;
  color: white;
  height: 7rem;
}

.navbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem 1rem;
  position: relative;
}

.logo-link {
  display: flex;
  align-items: center;
  text-decoration: none;
  z-index: 1001;
}

.logo {
  max-height: 6.5rem;
  cursor: pointer;
  transition: opacity 0.3s ease;
}

.logo:hover {
  opacity: 0.85;
}

.hamburger {
  display: none;
  flex-direction: column;
  gap: 5px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 5px;
  z-index: 1001;
}

.hamburger span {
  display: block;
  width: 28px;
  height: 3px;
  background-color: white;
  transition: all 0.3s ease;
  border-radius: 2px;
}

.hamburger.active span:nth-child(1) {
  transform: translateY(8px) rotate(45deg);
}

.hamburger.active span:nth-child(2) {
  opacity: 0;
}

.hamburger.active span:nth-child(3) {
  transform: translateY(-8px) rotate(-45deg);
}

.nav-links {
  list-style: none;
  display: flex;
  gap: 1.5rem;
  margin: 0;
  padding: 0;
}

.nav-links a {
  color: white;
  text-decoration: none;
  font-weight: bold;
  font-size: 1.2rem;
}

.nav-links a:hover {
  text-decoration: underline;
}

/* Dropdown styles */
.dropdown {
  position: relative;
}

.dropdown-toggle {
  display: flex;
  align-items: center;
  gap: 0.3rem;
  cursor: pointer;
}

.arrow {
  font-size: 0.8rem;
  transition: transform 0.3s ease;
}

.arrow.open {
  transform: rotate(180deg);
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  background-color: #2e4a6b;
  list-style: none;
  padding: 0.5rem 0;
  margin: 0.5rem 0 0 0;
  min-width: 180px;
  border-radius: 4px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
  opacity: 0;
  visibility: hidden;
  transform: translateY(-10px);
  transition: all 0.3s ease;
  z-index: 1000;
}

/* Make the last dropdown (Tune In) open to the left to prevent overflow */
.nav-links li:last-child .dropdown-menu {
  left: auto;
  right: 0;
}

.dropdown-menu.show {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}

.dropdown-menu li {
  padding: 0;
}

.dropdown-menu a {
  display: block;
  padding: 0.7rem 1.2rem;
  font-size: 1rem;
  transition: background-color 0.2s ease;
}

.dropdown-menu a:hover {
  background-color: #3d5a7d;
  text-decoration: none;
}

/* Mobile Styles */
@media (max-width: 768px) {
  .hamburger {
    display: flex;
  }

  .nav-links {
    position: fixed;
    top: 7rem;
    right: -100%;
    flex-direction: column;
    background-color: #003366;
    width: 220px;
    max-width: calc(100vw - 3rem);
    height: calc(100vh - 7rem);
    padding: 2rem 1.5rem;
    gap: 2rem;
    transition: right 0.3s ease;
    box-shadow: -2px 0 5px rgba(0, 0, 0, 0.3);
    z-index: 999;
    overflow-y: auto;
    overflow-x: hidden;
  }

  .nav-links.open {
    right: 1.5rem;
  }

  .nav-links li {
    width: 100%;
  }

  .nav-links a {
    display: block;
    padding: 0.5rem 0;
    font-size: 1.3rem;
  }

  /* Mobile dropdown adjustments */
  .dropdown {
    position: relative;
  }

  .dropdown-menu {
    position: static;
    background-color: #2e4a6b;
    margin: 0.5rem 0 0 0;
    padding: 0;
    box-shadow: none;
    border-radius: 4px;
    max-height: 0;
    overflow: hidden;
    opacity: 1;
    visibility: visible;
    transform: none;
    transition: max-height 0.3s ease, padding 0.3s ease;
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
  }

  .dropdown-menu.show {
    max-height: 200px;
    padding: 0.5rem 0;
  }

  .dropdown-menu a {
    font-size: 1.1rem;
    padding: 0.6rem 1rem;
    word-wrap: break-word;
    white-space: normal;
    overflow-wrap: break-word;
  }

  .dropdown-toggle {
    justify-content: space-between;
    width: 100%;
  }
}

/* Smaller mobile screens */
@media (max-width: 480px) {
  .site-header {
    height: 6rem;
  }

  .logo-link .logo {
    max-height: 5.5rem;
  }

  .nav-links {
    top: 6rem;
    height: calc(100vh - 6rem);
    width: 180px;
    max-width: calc(100vw - 3rem);
    padding: 1.5rem 1rem;
  }

  .nav-links.open {
    right: 1.5rem;
  }

  .nav-links a {
    font-size: 1.1rem;
  }

  .dropdown-menu a {
    font-size: 1rem;
    padding: 0.5rem 0.8rem;
  }
}
</style>
